import MD5 from 'md5.js'
// fields:需要同时满足相同的字段数组
export function getRowspanArr (tableData, fields) {
  const spanArr = []
  let point = 0
  tableData.forEach((item, index) => {
    if (index === 0) {
      spanArr.push(1)
    } else {
      let flag
      for (let i = 0; i < fields.length; i++) {
        if (i === 0) {
          flag = item[fields[0]] === tableData[index - 1][fields[0]]
        } else {
          flag = flag && item[fields[i]] === tableData[index - 1][fields[i]]
        }
      }
      if (flag) {
        spanArr[point] += 1
        spanArr.push(0)
      } else {
        spanArr.push(1)
        point = index
      }
    }
  })
  return spanArr
}
export function getEncryptionPassword (username, password) {
  // md5(md5(username首字母)+md5(password))
  const usernameIndex0MD5 = new MD5()
  const passwordMD5 = new MD5()
  const Md5 = new MD5()
  const encryptionPassword = Md5.update((usernameIndex0MD5.update(username.charAt()).digest('hex') + passwordMD5.update(password).digest('hex'))).digest('hex')
  return encryptionPassword
}
// 长数组按指定间隔分隔为子数组
export function sliceArray (arr, size) {
  var result = []
  for (var x = 0; x < Math.ceil(arr.length / size); x++) {
    var start = x * size
    var end = start + size
    result.push(arr.slice(start, end))
  }
  return result
}
